
export default function PlusIcon(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" {...props} width="20" height="19" viewBox="0 0 20 19" fill="none">
  <path d="M8.03245 0.0507812H11.749V7.59544H19.2937V11.312H11.749V18.8567H8.03245V11.312H0.487793V7.59544H8.03245V0.0507812Z" fill="black"/>
</svg>
}